export default __webpack_public_path__ + "static/media/Difference in Pick Rate vs Win Rate (Clash - SoloQ).864eff61.png";